import React, { useState } from "react";

interface CopyableIdProps {
  id: string;
  maxLength?: number;
  size?: "xs" | "sm" | "md";
}

// 複製圖標 SVG
const CopyIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
);

// 勾選圖標 SVG
const CheckIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);

export default function CopyableId({ id, maxLength = 12, size = "sm" }: CopyableIdProps) {
  const [copied, setCopied] = useState(false);

  const displayId =
    id.length > maxLength ? `${id.substring(0, maxLength)}...` : id;

  const sizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
  };

  const buttonSizeClasses = {
    xs: "w-5 h-5",
    sm: "w-6 h-6",
    md: "w-7 h-7",
  };

  const iconSizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error("複製失敗:", err);
      // 降級方案：使用傳統方法
      const textArea = document.createElement("textarea");
      textArea.value = id;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (fallbackErr) {
        console.error("降級複製方法也失敗:", fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className={`${sizeClasses[size]} font-mono text-surface-600 dark:text-surface-400`}>
        {displayId}
      </span>
      <button
        onClick={handleCopy}
        className={`flex items-center justify-center ${buttonSizeClasses[size]} rounded hover:bg-surface-200 dark:hover:bg-surface-700 transition-colors text-surface-500 dark:text-surface-400 hover:text-surface-700 dark:hover:text-surface-300`}
        title={copied ? "已複製" : "複製 ID"}
      >
        {copied ? (
          <CheckIcon className={`${iconSizeClasses[size]} text-green-600 dark:text-green-400`} />
        ) : (
          <CopyIcon className={iconSizeClasses[size]} />
        )}
      </button>
    </div>
  );
}

